import {humanFileSize} from '@/utils/tools'

function toggleCheckAll (event) {
  // 处理多个input toggle的问题
  let checked = null
  if (!event) {
    checked = document.querySelector('input[class="main-input-toggle"]').checked
  } else {
    checked = event.target.checked
  }
  let mainNode = event ? event.target.closest('table') : document

  let blocks = mainNode.querySelectorAll('input[class="sub-input-toggle"]')
  for (let i = 0; i < blocks.length; i++) {
    if (blocks[i].checked !== checked) {
      blocks[i].click()
    }
  }

  // 发送事件
  this.$emit('input-check', this.getSelectedIds(false))
}

function toggleCheck (event) {
  // update selectedFilesObejct, selectedCount
  let id = event.target.getAttribute('data-id')
  if (event.target.checked) {
    this.selectedCount += 1
    this.selectedObject[id] = {
      id: id,
      size: JSON.parse(event.target.getAttribute('data-size') || '{}'),
      display: event.target.getAttribute('data-display') || '',
      count: event.target.getAttribute('data-count') || 1,
      name: event.target.getAttribute('data-name') || ''
    }
  } else {
    this.selectedCount -= 1
    delete this.selectedObject[event.target.getAttribute('data-id')]
  }

  // 更新selectedList, selectedIds,
  this.selectedList = Object.values(this.selectedObject).sort(function (a, b) {
    return a.id < b.id
  })
  let selectedIds = []
  let selectedDisplays = []
  for (let i = 0; i < this.selectedList.length; i++) {
    selectedIds.push(this.selectedList[i].id)
    selectedDisplays.push(this.selectedList[i].display)
  }
  this.selectedIds = selectedIds
  this.selectedDisplays = selectedDisplays

  // 更新size
  let size = {}
  for (let index in this.selectedList) {
    let object = this.selectedList[index]
    for (let key in object.size) {
      size[key] = (size[key] || 0) + object.size[key] * object.count
    }
  }
  for (let key in size) {
    size[key] = humanFileSize(size[key])
  }
  this.size = size

  // 更新类型
  let productName = {}
  for (let item of this.selectedList) {
    productName[item.name] = (productName[item.name] || 0) + 1
  }
  this.productName = productName

  // 发送事件
  this.$emit('input-check', this.getSelectedIds(false))
}

function toggleCheckSortedByTable (event) {
  // 按照Table的顺序排序
  let selectedIds = []
  document.querySelectorAll('input[class="sub-input-toggle"]:checked').forEach(function (element) {
    selectedIds.push(element.getAttribute('data-id'))
  })
  this.selectedIds = selectedIds
  this.$emit('input-check', this.getSelectedIds(false))
}

function flushSelectedIds () {
  this.selectedObject = {}
  this.selectedIds = []
  this.selectedDisplays = []
  this.selectedList = []
  this.size = {}
}

function getSelectedIds (emptyAlert = true) {
  if (this.selectedIds.length === 0 && emptyAlert) {
    alert('您什么也没有选中')
  }
  return this.selectedIds
}

export default {
  methods: {
    toggleCheckAll,
    // 计算选中的个数
    toggleCheck,
    toggleCheckSortedByTable,
    flushSelectedIds,
    getSelectedIds
  },
  data () {
    return {
      selectedObject: {},
      selectedIds: [],
      selectedDisplays: [],
      selectedList: [],
      size: {},
      productName: {}
    }
  }
}
